exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tlist[data-v-d86a8cbc] {\n  border: none;\n}", ""]);

// exports
